import { requestBaseService } from './index'

export const getCategories = (payload) => {
  return requestBaseService({
    url: 'content/ex/v1/category',
    method: 'get',
    params: payload.params,
  })
}

const Categories = {
  getCategories
}

export default Categories
